<app-notify-message></app-notify-message>
<app-reports-header></app-reports-header>
<div class="tab-content">
  <div role="tabpanel" class="tab-pane fade in active show relative" id="general">
    <div class="row no-gutters reports-page">
      <div class="p-0 col-sm-0" [ngClass]="{'col-md-2': !isSideMenuClose, 'no-width': isSideMenuClose}">
        <app-reports-side-menu (selectReport)="getReport($event)"></app-reports-side-menu>
      </div>
      <div class="reports-body col-sm-12 p-0" [ngClass]="{'col-md-10': !isSideMenuClose, 'col-md-12': isSideMenuClose}">
        <!-- Collapse/Expand reports side menu -->
        <div class="toggle-collapse-wrapper">
          @if (!isSideMenuClose) {
<span
           
            ngbTooltip="Collapse Side Panel"
            placement="right"
            (click)="onSideMenuToggle()"
            class="toggleBtn badge badge-secondary">
            <i class="fa fa-angle-double-left font-14" aria-hidden="true"></i>
          </span>
}
          @if (isSideMenuClose) {
<span
           
            ngbTooltip="Expand Side Panel"
            placement="right"
            (click)="onSideMenuToggle()"
            class="toggleBtn badge badge-secondary">
            <i class="fa fa-angle-double-right font-14" aria-hidden="true"></i>
          </span>
}
        </div>
        <!-- Reports content along with the action row -->
        <div class="row no-gutters action-row align-items-center pr-2 pl-2">
          <div class="col-md-3">
            <h4 class="report-heading page-heading"><i class="fa fa-bar-chart"></i> {{currentReport.name}}</h4>
          </div>
          <div class="col-md-9 text-right">
            @if (currentReport.type !== 'VIN_CHANGE_2G2K' && currentReport.type !== 'DEVICE_COMMUNICATION_HEAT_MAP' && currentReport.type !== 'VPACKET_SYSTEM_REPORT') {
<app-search-select-device
             
              [autoSelect]="true"
              [selectSearchCategory]="true"
              [querySelectDevice]="querySelectVehicle"
              (deviceChangeEvent)="changeVehicle($event)"
              >
            </app-search-select-device>
}
            @if (currentReport.type == 'VIN_CHANGE_2G2K' && currentReport.type !== 'DEVICE_COMMUNICATION_HEAT_MAP' && currentReport.type !== 'VPACKET_SYSTEM_REPORT') {
<app-search-select-device
             
              [autoSelect]="true"
              [selectSearchCategory]="true"
              [querySelectDevice]="querySelectDevice"
              (deviceChangeEvent)="changeDevice($event)"
              >
            </app-search-select-device>
}
            <div class="calendar ml-2 d-inline-block" (clickOutside)="hideCalendar=!hideCalendar;">
              @if (currentReport.type !== 'DEVICE_COMMUNICATION_HEAT_MAP' && currentReport.type !== 'VPACKET_SYSTEM_REPORT') {
<app-date-time-calendar
               
                [clickOutside]="hideCalendar"
                [selectPreset]="'today'"
                [vehicle]="searchModel.vehicle"
                [device]="searchModel.device"
                (timeChangeEvent)="onTimeChange($event)">
              </app-date-time-calendar>
}
              @if (currentReport.type == 'DEVICE_COMMUNICATION_HEAT_MAP') {
<app-date-time-calendar
               
                [hideLinks]="['today', '15mins', '30mins', '1hour', '4hours', '12hours', '24hours', 'todaysofar', '90days', '180days', '365days']"
                [selectPreset]="'7days'"
                [maxRangeDays]="365"
                [clickOutside]="hideCalendar"
                [selectPreset]="'today'"
                [vehicle]="searchModel.vehicle"
                [device]="searchModel.device"
                [timeSelection]="false"
                (timeChangeEvent)="onTimeChange($event)">
              </app-date-time-calendar>
}
            </div>
            @if (currentReport.type !== 'DEVICE_COMMUNICATION_HEAT_MAP') {
<button
             
              class="btn btn-icon ml-2"
              (click)="refresh()"
              ngbTooltip="Refresh"
              placement="top"
              [disabled]="isLoading">
              <i class="fa fa-refresh" aria-hidden="true"></i>
            </button>
}
          </div>
        </div>
        <div class="row limit-width mx-0 align-items-center mt-2">
          <div class="col-12">
            @if (reports.length) {
<div class="row">
              <div class="col-md-12">
                <!--<div class="w90 relative">-->
                <!-- <app-ngx-datatable [KeyUp]="pageCallback.bind(this)" [pageInfo]="pageInfo" [tableData]= "reports-old" [columnData]="columMenu"></app-ngx-datatable> -->
                <ngx-datatable
                  id="tableau" #dataTable
                  class="bootstrap alertTable registeredVehicle reportsTable wrapcell"
                  [loadingIndicator]="isLoading"
                  [rows]="reports"
                  [columns]=""
                  [columnMode]="'force'"
                  [headerHeight]="50"
                  [footerHeight]="50"
                  [limit]="pageInfo.limit"
                  [offset]="pageInfo.offset"
                  [count]="pageInfo.count"
                  [rowHeight]="'auto'"
                  [summaryRow]="false"
                  [scrollbarH]="true"
                  [columnMode]="'force'"
                  [reorderable]="true">
                  <ngx-datatable-column name="#" [sortable]="false" [width]="50">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      {{row.index}}
                    </ng-template>
                  </ngx-datatable-column>
                  @for (rm of columMenu; track rm) {

                    @if (!rm.key.includes('reportId')) {
<ngx-datatable-column [resizeable]="false"
                                          name="{{rm.displayName}}">
                      <ng-template ngx-datatable-header-template>
                        <span>{{rm.displayName}}</span>
                      </ng-template>
                      <!--<ng-template let-row="row" ngx-datatable-cell-template>
                        {{rm.key == 'eventTime'?(row[rm.key] | date : dateFormat) : row[rm.key] }}
                      </ng-template>-->
                      <ng-template let-row="row" ngx-datatable-cell-template>
                        @if (dateAttributes.includes(rm.key)) {
<span>{{row[rm.key] | date : dateFormat}}</span>
}
                        @if (!dateAttributes.includes(rm.key)) {
<span>{{row[rm.key]}}</span>
}
                        <!--{{rm.key == dateAttributes.includes(row[rm.key] | date : dateFormat) : row[rm.key])}}-->
                        <!--{{rm.key == 'eventTime'?(row[rm.key] | date : dateFormat) : row[rm.key] }}-->
                      </ng-template>
                    </ngx-datatable-column>
}
                  
}
                </ngx-datatable>
                @if (totalMessageCount || this.currentReport.selectionType == 'GROUP') {
<div class="total-count">
                  Showing
                  <span contenteditable="false" (input)="currentPageCount.start = $any($event.target).innerText">
                    {{currentPageCount.start}}
                  </span>
                  -
                  <span contenteditable="false" (input)="currentPageCount.end = $any($event.target).innerText">
                    {{currentPageCount.end}}
                  </span>
                  of @if (this.currentReport.selectionType == 'GROUP') {
<span> many</span>
} @if (this.currentReport.selectionType !== 'GROUP') {
<span
                 > {{(totalMessageCount.count)}}</span>
} records.
                </div>
}
                <!--</div>-->
              </div>
            </div>
}
            @if (!reports.length) {
<div class="row">
              <div class="col-12 reports-download-btn text-center">
                @if (currentReport.type !== 'VIN_CHANGE_2G2K' && currentReport.type !== 'DEVICE_COMMUNICATION_HEAT_MAP') {
<button
                 
                  type="button" (click)="downloadReportCSV()"
                  [disabled]="disable"
                  class="btn btn-primary ml-2">
                  <i class="fa fa-cloud-download mr-2"></i> Download
                </button>
}
                @if (currentReport.type == 'VIN_CHANGE_2G2K' && currentReport.type !== 'DEVICE_COMMUNICATION_HEAT_MAP') {
<button
                 
                  style="min-width: 120px;" type="button"
                  (click)="downloadDeviceReportCSV()"
                  [disabled]="disable"
                  class="btn btn-primary ml-2">
                  <i class="fa fa-cloud-download mr-2"></i> Download
                </button>
}
                @if (currentReport.type == 'DEVICE_COMMUNICATION_HEAT_MAP') {
<button
                 
                  style="min-width: 120px;" type="button"
                  (click)="downloadHeatMapCSV()"
                  [disabled]="disable"
                  class="btn btn-primary ml-2">
                  <i class="fa fa-cloud-download mr-2"></i> Download
                </button>
}
              </div>
            </div>
}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
